<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="M12 11.333c-.367 0-.68-.13-.942-.391a1.284 1.284 0 0 1-.391-.942V6c0-.367.13-.68.391-.942.261-.26.575-.391.942-.391h2c.367 0 .68.13.942.391.26.261.391.575.391.942v4c0 .367-.13.68-.391.942a1.284 1.284 0 0 1-.942.391h-2Zm-11.333 0V10h2.666V8.667H2c-.367 0-.68-.13-.942-.392a1.284 1.284 0 0 1-.391-.942V6c0-.367.13-.68.391-.942A1.29 1.29 0 0 1 2 4.667h2.667V6H2v1.333h1.333c.367 0 .681.13.942.392.261.261.392.575.392.942V10c0 .367-.13.68-.392.942a1.284 1.284 0 0 1-.942.391H.667ZM12 10h2V6h-2v4Zm-6.333 0v1.333h2.666c.367 0 .68-.13.942-.391.261-.261.392-.575.392-.942V8.667c0-.367-.13-.68-.392-.942a1.284 1.284 0 0 0-.942-.392H7V6h2.667V4.667H7c-.367 0-.68.13-.942.391A1.284 1.284 0 0 0 5.667 6v1.333c0 .367.13.68.391.942.261.261.575.392.942.392h1.333V10H5.667Z"
        />
    </svg>
</template>

<script setup lang="ts">
type SSOIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<SSOIconProps>();
</script>
